import { render, staticRenderFns } from "./schedulingTabs.vue?vue&type=template&id=bcecc52e"
import script from "./schedulingTabs.vue?vue&type=script&lang=js"
export * from "./schedulingTabs.vue?vue&type=script&lang=js"
import style0 from "./schedulingTabs.vue?vue&type=style&index=0&id=bcecc52e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports